import { useMutation } from '@tanstack/react-query';

import {
  useInvalidateChannelById,
  useInvalidateChannelsList,
} from '@/entities/channel';
import { ApiError } from '@/shared/api/ApiError';
import { disconnectMaxPersonal } from '@/shared/api/channels/maxPersonal';
import { useNotifications } from '@/shared/ui/Notifications';

export function useMaxPersonalDisconnect() {
  const invalidateChannelsList = useInvalidateChannelsList();
  const invalidateChannelById = useInvalidateChannelById();
  const { addNotification } = useNotifications();

  const mutation = useMutation<void, ApiError, string>({
    mutationFn: (channelId) => disconnectMaxPersonal(channelId),
    onSuccess: async (_, channelId) => {
      await invalidateChannelsList();
      await invalidateChannelById(channelId);
    },
    onError: (error) => {
      addNotification({
        title: error.message,
        caption: error?.data?.details,
      });
    },
  });

  const disconnect = async (
    channelId: string,
    onDisconnected?: () => void
  ): Promise<void> => {
    return mutation.mutateAsync(channelId, {
      onSuccess: onDisconnected,
    });
  };

  return { disconnect, ...mutation };
}
